import {SpacerBlock} from 'Event/Marketplace/Block/Spacer'

export const createSpacerBlock = (): SpacerBlock => ({
  type: 'Spacer',
  visibility: 'desktop_only',
  background: {
    image: '',
    color: '',
    opacity: 0,
  },
  padding: {
    top: 10,
    right: 10,
    bottom: 10,
    left: 10,
  },
  alignment: {
    vertical: 'center',
    horizontal: 'center',
  },
  border: {
    width: 0,
    color: '#FFFFFF',
    radius: 0,
  },
})
